import { render, staticRenderFns } from "./swipeTop.vue?vue&type=template&id=425de813&scoped=true&"
import script from "./swipeTop.vue?vue&type=script&lang=js&"
export * from "./swipeTop.vue?vue&type=script&lang=js&"
import style0 from "./swipeTop.vue?vue&type=style&index=0&id=425de813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425de813",
  null
  
)

export default component.exports